<template>
  <div class="extras-form">
    <h3 v-html="$store.state.app_data.addons_title"></h3>

    <p v-html="$store.state.app_data.addons_description"></p>

    <div class="extras-form__categories-container">
      <div class="extras-form__categories">
        <button
          v-for="(category, n) in categories()"
          :class="categoryClass(category)"
          :key="`${category}-${n}`"
          @click.prevent="toggleFeeCategory(category)"
        >
          {{category}}
        </button>
        <div class="extras-form__category extras-form__category--spacer"></div>
      </div>
    </div>

    <div class="extras-table">
      <div
        v-for="(fee, n) in optionalFees()"
        class="table-row"
        :key="`fee-${fee.id}`"
        v-if="showFee(n)"
      >
        <div class="table-data table-data__image-wrapper">
          <img v-if="!!fee.image" :src="fee.image.url" :alt="fee.image.alt"/>
        </div>
        <div class="table-data table-data__description">
          <div v-if="!!fee.description && Object.keys(fee.description).length > 0" class="table-title">
            <div class="table-tooltip-wrapper">
              <button @click="() => toggleFeeNameToolTipShowing(fee.name)" type="button">
                {{ fee.name }}
              </button>
              <div class="table-tooltip" :class="feeNameToolTipShowingLookupTable[fee.name] ? false : 'table-tooltip--close'">
                <h4 class="table-tooltip__header">{{ fee.name }}</h4>
                <div class="table-tooltip__body">{{ fee.description }}</div>
              </div>
            </div>
          </div>
          <div v-else class="table-title">{{ fee.name }}</div>
          <div class="field-group field-group--tablet">
            <NumberInput
              :name="`optional_fee_${fee.id}`"
              v-model="$store.state.form[`optional_fee_${fee.id}`]"
              :max="fee.allow_multiple ? 10 : 1"
              @input="submitExtras"
            />
          </div>
          <div class="table-price">$ {{ feeValue(fee) }}</div>
        </div>
        <div class="table-data table-data__quantity table-data--mobile">
          <div class="field-group">
            <NumberInput
                :name="`optional_fee_${fee.id}`"
                v-model="_self[`optional_fee_${fee.id}`]"
                :max="fee.allow_multiple ? 10 : 1"
                @input="submitExtras"
            />
          </div>
        </div>
        <div class="table-data table-data__unit-price">
          <div class="table-title">$ {{ feeValue(fee) }}</div>
        </div>
        <div class="table-data table-data__total">
          <div class="table-title table-title--bold">$ {{ feeTotal(fee) }}</div>
        </div>
      </div>
    </div>

    <div v-show="optionalFees().length >= 5" class="more-extras">

      <button @click.prevent="toggleMore">
        <div class="more-extras__plus-box">
          <InlineSvg v-if="!state.show_more" src="images/icons/icon-plus.svg"></InlineSvg>
          <InlineSvg v-if="state.show_more" src="images/icons/icon-minus.svg"></InlineSvg>
        </div>
        <div class="more-extras__text">
          {{ this.show_more_text() }}
        </div>
      </button>

    </div>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import InlineSvg from 'vue-inline-svg';
import NumberInput from './NumberInput.vue';
// import PlusIcon from 'icons/icon-plus.svg?inline';
// import MinusIcon from 'icons/icon-minus.svg?inline';
import store from "./store";
import axios from "axios";

let opt_fees;

if (
  typeof store.state.breakdown == 'undefined' ||
  typeof store.state.breakdown.optional_fees == 'undefined' ||
  typeof store.state.breakdown.optional_fees[Symbol.iterator] !== 'function'
) {
  opt_fees = []
} else {
  opt_fees = store.state.breakdown.optional_fees.filter(fee => fee.name !== 'State Tax' && fee.name !== 'County Tax')
}

const unitPriceLookupTable = opt_fees.reduce( (accumulator, fee) => {
  if (accumulator !== undefined && fee.hasOwnProperty('id')) {
    let value = fee.value
    if (fee.quantity > 0) value = value / fee.quantity
    accumulator[fee.id] = value.toFixed(2)
    return accumulator
  }
}, {})


export default {
  components: {
    NumberInput,
    InlineSvg
  },
  data() {
    return {
      state: {
        show_more: false,
        current_fee_category: `All ${this.$store.state.app_data.addons_title}`
      },
      feeNameToolTipShowingLookupTable: {}
    }
  },
  mounted() {
    const optionalFees = this.optionalFees();
    if (optionalFees && optionalFees.length > 0 ) {
      optionalFees.forEach( fee => {
        this.feeNameToolTipShowingLookupTable[fee.name] = false;
      });
    }
  },
  methods: {
    toggleFeeNameToolTipShowing(feeName) {
      if (this.feeNameToolTipShowingLookupTable && Object.keys(this.feeNameToolTipShowingLookupTable).length > 0 ) {
        Object.keys(this.feeNameToolTipShowingLookupTable).forEach(v => {
          if (v !== feeName) {
            this.feeNameToolTipShowingLookupTable[v] = false
          }
        })
        this.feeNameToolTipShowingLookupTable[feeName] = !this.feeNameToolTipShowingLookupTable[feeName]
        this.$forceUpdate()
      }
    },
    show_more_text() {
      let adj = this.state.show_more ? 'Less' : 'More'
      return `${adj} ${this.$store.state.app_data.addons_title}`
    },
    categoryClass(category) {
      let classes = ['extras-form__category']
      if (category === this.state.current_fee_category) classes.push('selected')
      return classes.join(' ');
    },
    submitExtras() {
      let request = this.$store.state.request
      let form = this.$store.state.form
      let optionalKeys = Object.keys(form).filter(k => k.match('optional_fee'))

      optionalKeys.forEach(k => request[k] = form[k])

      this.$store.commit('updateQuoteRequest', request)

      // add authenticity_token for csrf protection
      request.authenticity_token = document.querySelector('[name="csrf-token"]').content

      axios
        .put('/checkout/quote', request)
        .then(({ data: response }) => {
          this.$store.commit('updateReservation', response)
        })
    },
    toggleMore() {
      this.state.show_more = !this.state.show_more
    },
    showFee(n) {
      return n < 5 || this.state.show_more
    },
    feeValue(fee) {
      if (unitPriceLookupTable.hasOwnProperty(fee.id)) {
        return unitPriceLookupTable[fee.id]
      }
      return 0.00
    },
    feeTotal(fee) {
      if (
          this.$store.state.form.hasOwnProperty(`optional_fee_${fee.id}`) &&
          this.$store.state.breakdown.hasOwnProperty('optional_fees')
      ) {
        const quantity = this.$store.state.form[`optional_fee_${fee.id}`]
        if (quantity > 0) {
          const f = this.$store.state.breakdown.optional_fees.find(f => f.id === fee.id)
          if (f) {
            return f.value
          }
        }
      }
      return 0
    },
    categories() {
      let cats = this.$store.state.app_data.fee_groups.map(group => group.name)
      cats.unshift(`All ${this.$store.state.app_data.addons_title}`)
      return cats
    },
    optionalFees() {
      let fees = opt_fees
      if (this.state.current_fee_category != `All ${this.$store.state.app_data.addons_title}`) {
        fees = fees.filter((fee) => {
          let foundFee = this.$store.state.app_data.optional_fees[fee.id]
          if (foundFee) {
            return foundFee.taxonomies.map(t => t.name).includes(this.state.current_fee_category)
          }
        })
      }

      fees = fees.reduce( (accumulator, fee) => {
        if (accumulator !== undefined) {
          if (
              fee.hasOwnProperty('id') &&
              this.$store.state.app_data.optional_fees.hasOwnProperty(fee.id) &&
              this.$store.state.app_data.optional_fees[fee.id].hasOwnProperty('image')
          ) {
            const image = this.$store.state.app_data.optional_fees[fee.id].image
            return accumulator.concat({
              ...fee,
              image: image
            })
          }
          return accumulator.concat(fee)
        }
      }, [])
      return fees
    },
    toggleFeeCategory(category) {
      this.state.current_fee_category = category
    }
  }
}
</script>

<style>
.extras-form {
  padding: 20px 0 40px;

  h3,
  p,
  .extras-table,
  .more-extras,
  &__categories {
    padding: 0 28px;
  }

  .extras-table {
    margin: 20px auto 40px auto;
  }

  .table-row {
    display: flex;
    margin: 20px auto;
  }

  .table-data {
    &:first-child {
      width: 25%;
      flex-shrink: 0;
    }

    &:last-child {
      padding: 0 0 0 20px;
    }

    &__unit-price,
    &__total {
      display: none;
    }

    &__description {
      margin: 0 0 0 20px;
      flex-basis: 40%;
    }

    &__quantity {
      margin: 0 0 0 20px;
      .number-input input {
        height: 48px;
      }
    }
    &__image-wrapper {
      position: relative;
      max-width: 86px;
      &:before {
        display: block;
        content: "";
        width: 100%;
        padding-top: 100%;
      }
      > img {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        height: 100%;
        object-fit: cover;
      }
    }
  }

  .table-title,
  .table-price {
    font-size: 14px;
    line-height: 1.29;
    letter-spacing: 0.25px;
    color: #042f5b;
    &--bold {
      font-weight: 800;
    }
  }

  .table-title {
    margin-bottom: 5px;
  }

  .table-price {
    color: #555555;
  }

  p {
    margin: 20px auto;
  }

  &__categories {
    display: flex;
    flex-direction: row;
  }

  &__categories-container {
    overflow-x: auto;
  }

  &__category {
    padding: 15px 20px;
    background: #fff;
    border: 1px solid #042f5b;
    color: #042f5b;
    flex-grow: 0;
    white-space: nowrap;
    margin: 0 10px 0 0;
    &:last-child {
      margin: 0 40px 0 0;
    }
    &.selected {
      background: #042f5b;
      color: #fff;
    }

    &--spacer {
      width: 1px;
      border: 0;
      background: transparent;
      padding: 10px;
    }
  }

  .more-extras {
    &__text {
      font-size: 20px;
      line-height: 1.3;
      letter-spacing: 0.31px;
      color: #042f5b;
      margin: 0 0 0 10px;
    }

    &__plus-box {
      line-height: 1;
      height: 26px;
      font-size: 0;
    }

    button {
      display: flex;
    }
  }

  .number-input {
    width: 64px;
  }

  .table-tooltip-wrapper {
    position: relative;
    display: inline;
    button {
      text-decoration: underline;
      text-underline-position: under;
      line-height: 1.5;
      color: $blueWhale;
      text-align: left;
      cursor: pointer;
    }
  }
  .table-tooltip {
    position: absolute;
    padding: 15px;
    width: 230px;
    color: $white;
    background-color: $blueWhale;
    font-size: 14px;
    bottom: calc(100% + 20px);
    left: 50%;
    transform: translateX(-50%);
    &--close {
      display: none;
    }
    &:after {
      content: "";
      position: absolute;
      top: 100%;
      left: 50%;
      transform: translateX(-50%);
      border: 10px solid #000;
      border-color: $blueWhale transparent transparent transparent;
    }
    &__header {
      color: $white;
      font-size: 14px;
      margin-bottom: 10px;
    }
    &__body {
      color: $white;
      font-size: 14px;
    }
  }


  @mixin breakpoint $tablet {

    h3,
    p,
    .extras-table,
    .more-extras,
    &__categories {
      padding: 0 50px;
    }

    p {
      max-width: 600px;
      margin: 20px 0;
      font-size: 16px;
    }

    .table-price {
      display: none;
    }

    .table-data {
      &__unit-price,
      &__total {
        display: block;
        flex-basis: 15%;
      }

      &__quantity {
        flex-basis: 10%;
      }

      &__description {
        margin: 0 0 0 30px;
        flex-basis: 35%;
      }
      &--mobile {
        display: none;
      }

    }

    .table-title {
      margin-bottom: 15px;
    }

    .number-input {
      width: 80px;
    }

  }
}
</style>
